import type { FireflyRuntime } from "@squide/firefly";
import { registerLazyI18nextInstance } from "@packages/core-client/i18n/registerLazyI18nextInstance.ts";

export const engagementI18NextInstanceKey = "engagement-module";

export function initEngagementI18next(runtime: FireflyRuntime) {
    registerLazyI18nextInstance(runtime, engagementI18NextInstanceKey, {
        "en-US": async () => (await import("./en.ts")).en,
        "fr-CA": async () => (await import("./fr.ts")).fr
    });
}
